module.exports = __webpack_public_path__ + "static/media/male_lying_portrait.ea126039.jpg";